export function createUi({
  stateA,
  onStateChange,
  onPlaybackAction,
  onApplyPreset,
  onPresetLockChange,
  onSaveState,
  onLoadState,
  onLoadEtopoAoi,
  onLoadTerrainFile,
  onBuildEtopoSurface,
  onClearEtopoSurface,
  onLoadWreckStl,
  onClearWreckStl,
  onGenerateMissionPlan,
  onOptimizeMissionHeading,
}) {
  const playBtn = document.getElementById("play-btn");
  const recordBtn = document.getElementById("record-btn");
  const pauseBtn = document.getElementById("pause-btn");
  const stepBtn = document.getElementById("step-btn");
  const trackingBtn = document.getElementById("tracking-btn");
  const resetBtn = document.getElementById("reset-btn");
  const toggleGraphsBtn = document.getElementById("toggle-graphs-btn");
  const toggleMetricsBtn = document.getElementById("toggle-metrics-btn");
  const presetEl = document.getElementById("scenario-preset");
  const applyPresetBtn = document.getElementById("apply-preset-btn");
  const saveStateBtn = document.getElementById("save-state-btn");
  const loadStateBtn = document.getElementById("load-state-btn");
  const loadStateFileInput = document.getElementById("load-state-file");
  const lockPresetEl = document.getElementById("lock-preset");
  const recenterBtn = document.getElementById("recenter-btn");
  const reframeAoiBtn = document.getElementById("reframe-aoi-btn");
  const cameraViewBirdsEyeBtn = document.getElementById("camera-view-birds-eye-btn");
  const cameraViewObliqueBehindBtn = document.getElementById("camera-view-oblique-behind-btn");
  const cameraViewObliqueAheadBtn = document.getElementById("camera-view-oblique-ahead-btn");
  const svpLayeredControlsEl = document.getElementById("svp-layered-controls");
  const trueSvpLayeredControlsEl = document.getElementById("true-svp-layered-controls");
  const soundVelocityInput = document.getElementById("sound-velocity");
  const trueSoundVelocityInput = document.getElementById("true-sound-velocity");
  const etopoControlsEl = document.getElementById("etopo-aoi-controls");
  const loadEtopoAoiBtn = document.getElementById("load-etopo-aoi-btn");
  const loadTerrainFileBtn = document.getElementById("load-terrain-file-btn");
  const buildEtopoSurfaceBtn = document.getElementById("build-etopo-surface-btn");
  const clearEtopoSurfaceBtn = document.getElementById("clear-etopo-surface-btn");
  const loadEtopoAoiFileInput = document.getElementById("load-etopo-aoi-file");
  const loadTerrainFileInput = document.getElementById("load-terrain-file");
  const etopoProgressEl = document.getElementById("etopo-aoi-progress");
  const etopoProgressBarEl = document.getElementById("etopo-aoi-progress-bar");
  const etopoStatusEl = document.getElementById("etopo-aoi-status");
  const verticalExaggerationInput = document.getElementById("vertical-exaggeration");
  const verticalExaggerationOutput = document.getElementById("vertical-exaggeration-out");
  const loadWreckStlBtn = document.getElementById("load-wreck-stl-btn");
  const clearWreckStlBtn = document.getElementById("clear-wreck-stl-btn");
  const loadWreckStlFileInput = document.getElementById("load-wreck-stl-file");
  const wreckStlStatusEl = document.getElementById("wreck-stl-status");
  const generateMissionPlanBtn = document.getElementById("generate-mission-plan-btn");
  const missionPlanStatusEl = document.getElementById("mission-plan-status");
  const optimizeMissionHeadingBtn = document.getElementById("optimize-mission-heading-btn");
  const attitudeGraphEl = document.getElementById("attitude-graph");
  const nadirGraphEl = document.getElementById("nadir-graph");
  const rawStripGraphEl = document.getElementById("raw-strip-graph");
  const densityQualityGraphEl = document.getElementById("density-quality-graph");
  const densityHistogramGraphEl = document.getElementById("density-histogram-graph");
  const densityStatsEl = document.getElementById("density-stats");

  const controlConfig = [
    { id: "visualization-preset", key: "visualizationPreset", type: "select" },
    { id: "background-color", key: "backgroundColor", type: "color" },
    { id: "accuracy-mode", key: "accuracyMode", type: "select" },
    { id: "raytrace-mode", key: "raytraceMode", type: "select" },
    { id: "sounding-solution-mode", key: "soundingSolutionMode", type: "select" },
    { id: "beamforming-sv-used", key: "beamformingSvUsed", outId: "beamforming-sv-used-out", decimals: 0, type: "range" },
    { id: "beamforming-sv-true", key: "beamformingSvTrue", outId: "beamforming-sv-true-out", decimals: 0, type: "range" },
    { id: "svp-mode", key: "svpMode", type: "select" },
    { id: "frequency", key: "frequency", outId: "frequency-out", decimals: 0, type: "range" },
    { id: "pulse-width", key: "pulseWidth", outId: "pulse-width-out", decimals: 1, type: "range" },
    { id: "sound-velocity", key: "soundVelocity", outId: "sound-velocity-out", decimals: 0, type: "range" },
    { id: "sv-surface-velocity", key: "svSurfaceVelocity", outId: "sv-surface-velocity-out", decimals: 0, type: "range" },
    { id: "sv-deep-velocity", key: "svDeepVelocity", outId: "sv-deep-velocity-out", decimals: 0, type: "range" },
    { id: "sv-transition-depth", key: "svTransitionDepth", outId: "sv-transition-depth-out", decimals: 0, type: "range" },
    { id: "true-svp-mode", key: "trueSvpMode", type: "select" },
    { id: "true-sound-velocity", key: "trueSoundVelocity", outId: "true-sound-velocity-out", decimals: 0, type: "range" },
    { id: "true-sv-surface-velocity", key: "trueSvSurfaceVelocity", outId: "true-sv-surface-velocity-out", decimals: 0, type: "range" },
    { id: "true-sv-deep-velocity", key: "trueSvDeepVelocity", outId: "true-sv-deep-velocity-out", decimals: 0, type: "range" },
    { id: "true-sv-transition-depth", key: "trueSvTransitionDepth", outId: "true-sv-transition-depth-out", decimals: 0, type: "range" },
    { id: "range", key: "range", outId: "range-out", decimals: 0, type: "range" },
    { id: "speed", key: "speed", outId: "speed-out", decimals: 1, type: "range" },
    { id: "ping-rate", key: "pingRate", outId: "ping-rate-out", decimals: 0, type: "range" },
    { id: "raw-strip-update-rate", key: "rawStripUpdateRate", outId: "raw-strip-update-rate-out", decimals: 0, type: "range" },
    { id: "sim-time-scale", key: "simTimeScale", outId: "sim-time-scale-out", decimals: 0, type: "range" },
    { id: "history-length", key: "historyLength", outId: "history-length-out", decimals: 0, type: "range" },
    { id: "history-unlimited", key: "historyUnlimited", type: "checkbox" },
    { id: "camera-mode", key: "cameraMode", type: "select" },
    { id: "mission-lock-aoi", key: "missionLockAoi", type: "checkbox" },
    { id: "beam-count", key: "beamCount", type: "select" },
    { id: "beam-spacing-mode", key: "beamSpacingMode", type: "select" },
    { id: "beam-angle", key: "beamAngle", outId: "beam-angle-out", decimals: 0, type: "range" },
    { id: "etopo-grid-size", key: "etopoGridSize", outId: "etopo-grid-size-out", decimals: 0, type: "range" },
    { id: "roll-enabled", key: "rollEnabled", type: "checkbox" },
    { id: "roll-stabilization-enabled", key: "rollStabilizationEnabled", type: "checkbox" },
    { id: "roll-stabilization-strength", key: "rollStabilizationStrength", outId: "roll-stabilization-strength-out", decimals: 0, type: "range" },
    { id: "roll", key: "roll", outId: "roll-out", decimals: 1, type: "range" },
    { id: "roll-amplitude", key: "rollAmplitude", outId: "roll-amplitude-out", decimals: 1, type: "range" },
    { id: "roll-period", key: "rollPeriod", outId: "roll-period-out", decimals: 1, type: "range" },
    { id: "roll-variability", key: "rollVariability", outId: "roll-variability-out", decimals: 2, type: "range" },
    { id: "pitch-enabled", key: "pitchEnabled", type: "checkbox" },
    { id: "pitch-stabilization-enabled", key: "pitchStabilizationEnabled", type: "checkbox" },
    { id: "pitch-stabilization-strength", key: "pitchStabilizationStrength", outId: "pitch-stabilization-strength-out", decimals: 0, type: "range" },
    { id: "pitch", key: "pitch", outId: "pitch-out", decimals: 1, type: "range" },
    { id: "pitch-amplitude", key: "pitchAmplitude", outId: "pitch-amplitude-out", decimals: 1, type: "range" },
    { id: "pitch-period", key: "pitchPeriod", outId: "pitch-period-out", decimals: 1, type: "range" },
    { id: "pitch-variability", key: "pitchVariability", outId: "pitch-variability-out", decimals: 2, type: "range" },
    { id: "yaw-enabled", key: "yawEnabled", type: "checkbox" },
    { id: "yaw-stabilization-enabled", key: "yawStabilizationEnabled", type: "checkbox" },
    { id: "yaw-stabilization-strength", key: "yawStabilizationStrength", outId: "yaw-stabilization-strength-out", decimals: 0, type: "range" },
    { id: "yaw", key: "yaw", outId: "yaw-out", decimals: 0, type: "range" },
    { id: "yaw-amplitude", key: "yawAmplitude", outId: "yaw-amplitude-out", decimals: 1, type: "range" },
    { id: "yaw-period", key: "yawPeriod", outId: "yaw-period-out", decimals: 1, type: "range" },
    { id: "yaw-variability", key: "yawVariability", outId: "yaw-variability-out", decimals: 2, type: "range" },
    { id: "course", key: "course", outId: "course-out", decimals: 0, type: "range" },
    { id: "steerage", key: "steerage", outId: "steerage-out", decimals: 0, type: "range" },
    { id: "mission-plan-heading", key: "missionPlanHeading", outId: "mission-plan-heading-out", decimals: 0, type: "range" },
    { id: "mission-plan-overlap", key: "missionPlanOverlap", outId: "mission-plan-overlap-out", decimals: 0, type: "range" },
    { id: "mission-plan-optimize-heading", key: "missionOptimizeHeading", type: "checkbox" },
    { id: "mission-plan-enabled", key: "missionPlanEnabled", type: "checkbox" },
    { id: "mission-plan-skip-turns", key: "missionSkipTurns", type: "checkbox" },
    { id: "seafloor-preset", key: "seafloorPreset", type: "select" },
    { id: "wreck-enabled", key: "wreckEnabled", type: "checkbox" },
    { id: "wreck-visible", key: "wreckVisible", type: "checkbox" },
    { id: "wreck-scale", key: "wreckScale", outId: "wreck-scale-out", decimals: 2, type: "range" },
    { id: "wreck-offset-x", key: "wreckOffsetX", outId: "wreck-offset-x-out", decimals: 0, type: "range" },
    { id: "wreck-offset-y", key: "wreckOffsetY", outId: "wreck-offset-y-out", decimals: 0, type: "range" },
    { id: "wreck-offset-z", key: "wreckOffsetZ", outId: "wreck-offset-z-out", decimals: 1, type: "range" },
    { id: "wreck-yaw", key: "wreckYaw", outId: "wreck-yaw-out", decimals: 0, type: "range" },
    { id: "wreck-roll", key: "wreckRoll", outId: "wreck-roll-out", decimals: 0, type: "range" },
    { id: "wreck-pitch", key: "wreckPitch", outId: "wreck-pitch-out", decimals: 0, type: "range" },
    { id: "wreck-embed", key: "wreckEmbed", outId: "wreck-embed-out", decimals: 1, type: "range" },
    { id: "wreck-sonar-triangles", key: "wreckSonarTriangles", outId: "wreck-sonar-triangles-out", decimals: 0, type: "range" },
    { id: "swath-fill-color", key: "swathFillColor", type: "color" },
    { id: "swath-beams-color", key: "swathBeamsColor", type: "color" },
    { id: "swath-outline-color", key: "swathOutlineColor", type: "color" },
    { id: "sounding-points-color", key: "soundingPointsColor", type: "color" },
    { id: "sounding-color-mode", key: "soundingColorMode", type: "select" },
    { id: "sounding-color-ramp", key: "soundingColorRamp", type: "select" },
    { id: "sounding-color-invert", key: "soundingColorInvert", type: "checkbox" },
    { id: "sounding-depth-mode", key: "soundingDepthMode", type: "select" },
    { id: "sounding-depth-min", key: "soundingDepthMin", outId: "sounding-depth-min-out", decimals: 0, type: "range" },
    { id: "sounding-depth-max", key: "soundingDepthMax", outId: "sounding-depth-max-out", decimals: 0, type: "range" },
    { id: "history-soundings-color", key: "historySoundingsColor", type: "color" },
    { id: "boat-color", key: "boatColor", type: "color" },
    { id: "boat-shape", key: "boatShape", type: "select" },
    { id: "water-surface-color", key: "waterSurfaceColor", type: "color" },
    { id: "seafloor-color", key: "seafloorColor", type: "color" },
    { id: "mesh-grid-color", key: "meshGridColor", type: "color" },
    { id: "swath-fill-opacity", key: "swathFillOpacity", type: "range" },
    { id: "swath-beams-opacity", key: "swathBeamsOpacity", type: "range" },
    { id: "swath-outline-opacity", key: "swathOutlineOpacity", type: "range" },
    { id: "soundings-opacity", key: "soundingsOpacity", type: "range" },
    { id: "history-soundings-opacity", key: "historySoundingsOpacity", type: "range" },
    { id: "boat-opacity", key: "boatOpacity", type: "range" },
    { id: "water-surface-opacity", key: "waterSurfaceOpacity", type: "range" },
    { id: "seafloor-opacity", key: "seafloorOpacity", type: "range" },
    { id: "mesh-grid-opacity", key: "meshGridOpacity", type: "range" },
    { id: "mesh-grid-spacing", key: "meshGridSpacing", type: "select" },
    { id: "grid-nodes-enabled", key: "gridNodesEnabled", type: "checkbox" },
    { id: "grid-surface-mode", key: "gridSurfaceMode", type: "select" },
    { id: "grid-surface-hillshade", key: "gridSurfaceHillshade", type: "checkbox" },
    { id: "grid-hillshade-azimuth", key: "gridHillshadeAzimuth", outId: "grid-hillshade-azimuth-out", decimals: 0, type: "range" },
    { id: "grid-hillshade-elevation", key: "gridHillshadeElevation", outId: "grid-hillshade-elevation-out", decimals: 0, type: "range" },
    { id: "grid-surface-mask-nodata", key: "gridSurfaceMaskNoData", type: "checkbox" },
    { id: "grid-node-metric", key: "gridNodeMetric", type: "select" },
    { id: "grid-node-color-ramp", key: "gridNodeColorRamp", type: "select" },
    { id: "grid-node-opacity", key: "gridNodeOpacity", outId: "grid-node-opacity-out", decimals: 2, type: "range" },
    { id: "grid-node-size", key: "gridNodeSize", outId: "grid-node-size-out", decimals: 1, type: "range" },
    { id: "density-target-primary", key: "densityTargetPrimary", outId: "density-target-primary-out", decimals: 0, type: "range" },
    { id: "density-target-secondary", key: "densityTargetSecondary", outId: "density-target-secondary-out", decimals: 0, type: "range" },
    { id: "density-quality-basis", key: "densityQualityBasis", type: "select" },
    { id: "density-painting-enabled", key: "densityPaintingEnabled", type: "checkbox" },
    { id: "show-swath-fill", key: "showSwathFill", type: "checkbox" },
    { id: "show-swath-beams", key: "showSwathBeams", type: "checkbox" },
    { id: "show-swath-outline", key: "showSwathOutline", type: "checkbox" },
    { id: "show-soundings", key: "showSoundings", type: "checkbox" },
    { id: "show-history-soundings", key: "showHistorySoundings", type: "checkbox" },
    { id: "show-boat", key: "showBoat", type: "checkbox" },
    { id: "show-water-surface", key: "showWaterSurface", type: "checkbox" },
    { id: "show-seafloor", key: "showSeafloor", type: "checkbox" },
    { id: "mesh-grid-enabled", key: "meshGridEnabled", type: "checkbox" },
  ];

  const controls = controlConfig.map((item) => ({
    ...item,
    input: document.getElementById(item.id),
    output: item.outId ? document.getElementById(item.outId) : null,
  }));
  const syncSoundingDepthDualRange = setupSoundingDepthDualRange(controls);
  const syncHeadingDials = enhanceRangeLayout(controls);

  controls.forEach((control) => {
    const eventName = control.type === "range" || control.type === "color" ? "input" : "change";
    control.input.addEventListener(eventName, () => {
      if (control.id === "visualization-preset") {
        applyVisualizationPreset(control.input.value);
        return;
      }
      if (control.type === "checkbox") {
        stateA[control.key] = control.input.checked;
      } else if (control.type === "color") {
        stateA[control.key] = control.input.value;
      } else if (control.type === "select" && isNumericSelect(control.key)) {
        stateA[control.key] = Number(control.input.value);
      } else if (control.type === "select") {
        stateA[control.key] = control.input.value;
      } else if (control.type === "range") {
        stateA[control.key] = Number(control.input.value);
      } else {
        stateA[control.key] = control.input.value;
      }
      if (control.id === "sounding-depth-min") {
        const maxValue = Number(stateA.soundingDepthMax) || 0;
        if (stateA.soundingDepthMin > maxValue) {
          stateA.soundingDepthMin = maxValue;
          control.input.value = String(maxValue);
        }
      } else if (control.id === "sounding-depth-max") {
        const minValue = Number(stateA.soundingDepthMin) || 0;
        if (stateA.soundingDepthMax < minValue) {
          stateA.soundingDepthMax = minValue;
          control.input.value = String(minValue);
        }
      }
      syncControlOutputs();
      onStateChange();
    });
  });

  playBtn.addEventListener("click", () => onPlaybackAction?.("play"));
  recordBtn?.addEventListener("click", () => onPlaybackAction?.("record"));
  pauseBtn.addEventListener("click", () => onPlaybackAction?.("pause"));
  stepBtn.addEventListener("click", () => onPlaybackAction?.("step"));
  trackingBtn.addEventListener("click", () => onPlaybackAction?.("toggleTracking"));
  resetBtn.addEventListener("click", () => onPlaybackAction?.("reset"));
  toggleGraphsBtn?.addEventListener("click", () => {
    stateA.showOverlayGraphs = !stateA.showOverlayGraphs;
    syncOverlayVisibility();
    onStateChange();
  });
  toggleMetricsBtn?.addEventListener("click", () => {
    stateA.showOverlayMetrics = !stateA.showOverlayMetrics;
    syncOverlayVisibility();
    onStateChange();
  });
  recenterBtn.addEventListener("click", () => onPlaybackAction?.("recenter"));
  reframeAoiBtn.addEventListener("click", () => onPlaybackAction?.("reframeAoi"));
  cameraViewBirdsEyeBtn?.addEventListener("click", () => onPlaybackAction?.("cameraPreset:birdsEye"));
  cameraViewObliqueBehindBtn?.addEventListener("click", () => onPlaybackAction?.("cameraPreset:obliqueBehind"));
  cameraViewObliqueAheadBtn?.addEventListener("click", () => onPlaybackAction?.("cameraPreset:obliqueAhead"));
  applyPresetBtn.addEventListener("click", () => onApplyPreset?.(presetEl.value));
  saveStateBtn.addEventListener("click", () => onSaveState?.());
  loadStateBtn.addEventListener("click", () => loadStateFileInput.click());
  loadStateFileInput.addEventListener("change", async () => {
    const [file] = loadStateFileInput.files || [];
    if (!file) {
      return;
    }
    await onLoadState?.(file);
    loadStateFileInput.value = "";
  });
  lockPresetEl.addEventListener("change", () => onPresetLockChange?.(lockPresetEl.checked));
  verticalExaggerationInput?.addEventListener("input", () => {
    stateA.verticalExaggeration = Number(verticalExaggerationInput.value);
    syncVerticalExaggeration();
    onStateChange();
  });
  loadEtopoAoiBtn.addEventListener("click", () => loadEtopoAoiFileInput.click());
  loadTerrainFileBtn?.addEventListener("click", () => loadTerrainFileInput?.click());
  loadEtopoAoiFileInput.addEventListener("change", async () => {
    const [file] = loadEtopoAoiFileInput.files || [];
    if (!file) {
      return;
    }
    await onLoadEtopoAoi?.(file);
    loadEtopoAoiFileInput.value = "";
  });
  loadTerrainFileInput?.addEventListener("change", async () => {
    const [file] = loadTerrainFileInput.files || [];
    if (!file) {
      return;
    }
    await onLoadTerrainFile?.(file);
    loadTerrainFileInput.value = "";
  });
  buildEtopoSurfaceBtn.addEventListener("click", async () => {
    await onBuildEtopoSurface?.();
  });
  clearEtopoSurfaceBtn.addEventListener("click", () => onClearEtopoSurface?.());
  loadWreckStlBtn?.addEventListener("click", () => loadWreckStlFileInput?.click());
  loadWreckStlFileInput?.addEventListener("change", async () => {
    const [file] = loadWreckStlFileInput.files || [];
    if (!file) {
      return;
    }
    await onLoadWreckStl?.(file);
    loadWreckStlFileInput.value = "";
  });
  clearWreckStlBtn?.addEventListener("click", () => onClearWreckStl?.());
  generateMissionPlanBtn?.addEventListener("click", () => onGenerateMissionPlan?.());
  optimizeMissionHeadingBtn?.addEventListener("click", () => onOptimizeMissionHeading?.());

  function syncControlOutputs() {
    controls.forEach((control) => {
      const value = stateA[control.key];
      if (control.type === "checkbox") {
        control.input.checked = Boolean(value);
      } else {
        control.input.value = String(value);
      }
      if (control.output) {
        control.output.textContent = Number(value).toFixed(control.decimals);
      }
    });
    applySvpVisibility();
    applyEtopoVisibility();
    applySeaAxisVisibility();
    applyHistoryMode();
    applySoundingColorVisibility();
    syncOverlayVisibility();
    syncHeadingDials();
    syncSoundingDepthDualRange();
    setTrackingMode(stateA.cameraMode);
    syncVerticalExaggeration();
  }

  function applyHistoryMode() {
    const unlimited = Boolean(stateA.historyUnlimited);
    const historyLengthInput = document.getElementById("history-length");
    if (historyLengthInput) {
      historyLengthInput.disabled = unlimited;
    }
  }

  function applySvpVisibility() {
    const layered = stateA.svpMode === "layered";
    const trueLayered = stateA.trueSvpMode === "layered";
    svpLayeredControlsEl.classList.toggle("is-hidden", !layered);
    soundVelocityInput.disabled = layered;
    trueSvpLayeredControlsEl.classList.toggle("is-hidden", !trueLayered);
    trueSoundVelocityInput.disabled = trueLayered;
  }

  function syncVerticalExaggeration() {
    if (verticalExaggerationInput) {
      const next = Math.max(1, Math.min(8, Number(stateA.verticalExaggeration) || 1));
      verticalExaggerationInput.value = String(next);
      if (verticalExaggerationOutput) {
        verticalExaggerationOutput.textContent = `${next.toFixed(1)}x`;
      }
    }
  }

  function applySoundingColorVisibility() {
    const rampEnabled = stateA.soundingColorMode !== "solid";
    const fixedDepth = stateA.soundingDepthMode === "fixed";
    const rampEl = document.getElementById("sounding-color-ramp");
    const invertEl = document.getElementById("sounding-color-invert");
    const minEl = document.getElementById("sounding-depth-min");
    const maxEl = document.getElementById("sounding-depth-max");
    if (rampEl) rampEl.disabled = !rampEnabled;
    if (invertEl) invertEl.disabled = !rampEnabled;
    if (minEl) minEl.disabled = !rampEnabled || !fixedDepth;
    if (maxEl) maxEl.disabled = !rampEnabled || !fixedDepth;
  }

  function setTrackingMode(mode) {
    const trackingEnabled = mode === "follow";
    trackingBtn.classList.toggle("active", trackingEnabled);
    trackingBtn.setAttribute("aria-pressed", String(trackingEnabled));
    trackingBtn.title = trackingEnabled ? "Vessel tracking: On" : "Vessel tracking: Off";
  }

  function setRecordingMode(isRecording) {
    if (!recordBtn) {
      return;
    }
    const on = Boolean(isRecording);
    recordBtn.classList.toggle("active", on);
    recordBtn.setAttribute("aria-pressed", String(on));
    recordBtn.title = on ? "Record Sonar: On" : "Record Sonar: Off";
  }

  function applyEtopoVisibility() {
    etopoControlsEl.classList.toggle("is-hidden", stateA.seafloorPreset !== "etopo_aoi");
  }

  function syncOverlayVisibility() {
    const showGraphs = stateA.showOverlayGraphs !== false;
    const showMetrics = stateA.showOverlayMetrics !== false;
    attitudeGraphEl?.classList.toggle("is-hidden", !showGraphs);
    nadirGraphEl?.classList.toggle("is-hidden", !showGraphs);
    rawStripGraphEl?.classList.toggle("is-hidden", !showGraphs);
    densityQualityGraphEl?.classList.toggle("is-hidden", !showGraphs);
    densityHistogramGraphEl?.classList.toggle("is-hidden", !showGraphs);
    densityStatsEl?.classList.toggle("is-hidden", !showMetrics);
    if (toggleGraphsBtn) {
      toggleGraphsBtn.classList.toggle("active", showGraphs);
      toggleGraphsBtn.setAttribute("aria-pressed", String(showGraphs));
    }
    if (toggleMetricsBtn) {
      toggleMetricsBtn.classList.toggle("active", showMetrics);
      toggleMetricsBtn.setAttribute("aria-pressed", String(showMetrics));
    }
  }

  function applyVisualizationPreset(presetId) {
    const presets = {
      clean_grid_daylight: {
        swathFillColor: "#5bbec7",
        swathBeamsColor: "#2f8894",
        soundingPointsColor: "#ffffff",
        historySoundingsColor: "#ffffff",
        historySoundingsOpacity: 0.72,
        showHistorySoundings: true,
        waterSurfaceColor: "#d2ecf2",
        waterSurfaceOpacity: 0.18,
        showWaterSurface: false,
        seafloorColor: "#4f6b55",
        showSeafloor: false,
        meshGridEnabled: true,
        meshGridColor: "#0ea5a3",
        meshGridOpacity: 0.5,
        backgroundColor: "#000000",
      },
      classic_sonar: {
        swathFillColor: "#ffa450",
        swathBeamsColor: "#ffcd8b",
        soundingPointsColor: "#fff3b0",
        historySoundingsColor: "#7cc6ff",
        historySoundingsOpacity: 0.6,
        showHistorySoundings: true,
        waterSurfaceColor: "#1a3f63",
        waterSurfaceOpacity: 0.37,
        showWaterSurface: false,
        seafloorColor: "#4f6b55",
        meshGridEnabled: true,
        meshGridColor: "#9ad7f2",
        meshGridOpacity: 0.55,
      },
      radium_grid: {
        swathFillColor: "#ff9b72",
        swathBeamsColor: "#ffd4a3",
        soundingPointsColor: "#ffe9bf",
        historySoundingsColor: "#66ffd9",
        historySoundingsOpacity: 0.62,
        showHistorySoundings: true,
        waterSurfaceColor: "#1a3f63",
        waterSurfaceOpacity: 0.34,
        showWaterSurface: false,
        seafloorColor: "#2d3552",
        meshGridEnabled: true,
        meshGridColor: "#ff5cf0",
        meshGridOpacity: 0.78,
      },
      abyss_neon: {
        swathFillColor: "#a65cff",
        swathBeamsColor: "#cf8dff",
        soundingPointsColor: "#ffd2ff",
        historySoundingsColor: "#76ffe2",
        historySoundingsOpacity: 0.72,
        showHistorySoundings: true,
        waterSurfaceColor: "#0e2242",
        waterSurfaceOpacity: 0.28,
        showWaterSurface: false,
        seafloorColor: "#2f3957",
        meshGridEnabled: true,
        meshGridColor: "#ff49d6",
        meshGridOpacity: 0.85,
      },
      ice_wire: {
        swathFillColor: "#93d7ff",
        swathBeamsColor: "#c7efff",
        soundingPointsColor: "#f2fdff",
        historySoundingsColor: "#8fe0ff",
        historySoundingsOpacity: 0.58,
        showHistorySoundings: true,
        waterSurfaceColor: "#204d78",
        waterSurfaceOpacity: 0.3,
        showWaterSurface: true,
        seafloorColor: "#3f5969",
        meshGridEnabled: true,
        meshGridColor: "#bfeaff",
        meshGridOpacity: 0.7,
      },
      ember_contrast: {
        swathFillColor: "#ff8f55",
        swathBeamsColor: "#ffd08e",
        soundingPointsColor: "#fff3bf",
        historySoundingsColor: "#79e5ff",
        historySoundingsOpacity: 0.62,
        showHistorySoundings: true,
        waterSurfaceColor: "#1c2c52",
        waterSurfaceOpacity: 0.32,
        showWaterSurface: true,
        seafloorColor: "#5d4637",
        meshGridEnabled: true,
        meshGridColor: "#ff6db2",
        meshGridOpacity: 0.68,
      },
    };
    const id = Object.prototype.hasOwnProperty.call(presets, presetId) ? presetId : "clean_grid_daylight";
    Object.assign(stateA, presets[id], { visualizationPreset: id });
    syncControlOutputs();
    onStateChange();
  }

  function applySeaAxisVisibility() {
    setAxisControlDisabled("roll", !stateA.rollEnabled, stateA.rollStabilizationEnabled);
    setAxisControlDisabled("pitch", !stateA.pitchEnabled, stateA.pitchStabilizationEnabled);
    setAxisControlDisabled("yaw", !stateA.yawEnabled, stateA.yawStabilizationEnabled);
  }

  syncControlOutputs();

  return {
    syncControlOutputs,
    setTrackingMode,
    setRecordingMode,
    setEtopoStatus(text) {
      etopoStatusEl.textContent = text;
    },
    setWreckStatus(text) {
      if (wreckStlStatusEl) {
        wreckStlStatusEl.textContent = text;
      }
    },
    setEtopoProgress(progress, visible = true) {
      const p = Math.max(0, Math.min(1, Number(progress) || 0));
      etopoProgressEl.classList.toggle("is-hidden", !visible);
      etopoProgressEl.setAttribute("aria-hidden", String(!visible));
      etopoProgressBarEl.style.width = `${Math.round(p * 100)}%`;
    },
    setMissionPlanStatus(text) {
      if (missionPlanStatusEl) {
        missionPlanStatusEl.textContent = text;
      }
    },
    setLocked(locked) {
      controls.forEach((control) => {
        control.input.disabled = locked;
      });
      loadEtopoAoiBtn.disabled = locked;
      if (verticalExaggerationInput) verticalExaggerationInput.disabled = locked;
      if (loadTerrainFileBtn) loadTerrainFileBtn.disabled = locked;
      buildEtopoSurfaceBtn.disabled = locked;
      clearEtopoSurfaceBtn.disabled = locked;
      if (recordBtn) recordBtn.disabled = locked;
      if (cameraViewBirdsEyeBtn) cameraViewBirdsEyeBtn.disabled = locked;
      if (cameraViewObliqueBehindBtn) cameraViewObliqueBehindBtn.disabled = locked;
      if (cameraViewObliqueAheadBtn) cameraViewObliqueAheadBtn.disabled = locked;
      if (loadWreckStlBtn) {
        loadWreckStlBtn.disabled = locked;
      }
      if (clearWreckStlBtn) {
        clearWreckStlBtn.disabled = locked;
      }
      if (generateMissionPlanBtn) {
        generateMissionPlanBtn.disabled = locked;
      }
      if (optimizeMissionHeadingBtn) {
        optimizeMissionHeadingBtn.disabled = locked;
      }
      if (!locked) {
        applySeaAxisVisibility();
        applyHistoryMode();
        applySoundingColorVisibility();
      }
      syncHeadingDials();
      lockPresetEl.checked = locked;
      presetEl.disabled = locked;
      applyPresetBtn.disabled = locked;
    },
  };
}

function isNumericSelect(key) {
  return key === "beamCount" || key === "meshGridSpacing";
}

function setAxisControlDisabled(axis, disabled, stabilizationEnabled) {
  const ids = [
    axis,
    `${axis}-amplitude`,
    `${axis}-period`,
    `${axis}-variability`,
  ];
  ids.forEach((id) => {
    const input = document.getElementById(id);
    if (input) {
      input.disabled = disabled;
    }
  });
  const stabToggle = document.getElementById(`${axis}-stabilization-enabled`);
  const stabStrength = document.getElementById(`${axis}-stabilization-strength`);
  if (stabToggle) {
    stabToggle.disabled = disabled;
  }
  if (stabStrength) {
    stabStrength.disabled = disabled || !stabilizationEnabled;
  }
}

function enhanceRangeLayout(controls) {
  const headingDialSyncFns = [];
  let headingDialRow = null;
  controls.forEach((control) => {
    if (control.type !== "range" || !control.input || !control.output) {
      return;
    }
    const label = document.querySelector(`label[for="${control.id}"]`);
    if (!label || label.closest(".range-field")) {
      return;
    }
    const originalParent = label.parentElement;
    const field = document.createElement("div");
    field.className = "range-field";

    const head = document.createElement("div");
    head.className = "range-head";
    label.replaceWith(field);
    field.appendChild(head);
    head.appendChild(label);

    if (control.id === "course" || control.id === "steerage") {
      control.output.style.display = "none";
      if (!headingDialRow && originalParent) {
        headingDialRow = document.createElement("div");
        headingDialRow.className = "heading-dial-row";
        originalParent.insertBefore(headingDialRow, field);
      }
      field.classList.add("dial-field");
      const dial = createHeadingDial(
        control.input,
        control.id === "course" ? "Course" : "Steerage",
        control.id === "course" ? "radium-a" : "radium-b",
      );
      field.appendChild(dial.root);
      control.input.classList.add("dial-hidden-range");
      field.appendChild(control.input);
      if (headingDialRow) {
        headingDialRow.appendChild(field);
      }
      headingDialSyncFns.push(dial.sync);
      return;
    }
    head.appendChild(control.output);

    field.appendChild(control.input);
    const labels = control.input.nextElementSibling;
    if (labels?.classList.contains("range-end-labels")) {
      field.appendChild(labels);
    }
  });
  return () => {
    headingDialSyncFns.forEach((sync) => sync());
  };
}

function setupSoundingDepthDualRange(controls) {
  const minControl = controls.find((c) => c.id === "sounding-depth-min");
  const maxControl = controls.find((c) => c.id === "sounding-depth-max");
  if (!minControl?.input || !minControl.output || !maxControl?.input || !maxControl.output) {
    return () => {};
  }
  const minLabel = document.querySelector('label[for="sounding-depth-min"]');
  const maxLabel = document.querySelector('label[for="sounding-depth-max"]');
  const parent = minLabel?.parentElement;
  if (!minLabel || !maxLabel || !parent || maxLabel.parentElement !== parent) {
    return () => {};
  }

  const field = document.createElement("div");
  field.className = "range-field dual-range-field";
  parent.insertBefore(field, minLabel);

  const head = document.createElement("div");
  head.className = "range-head";
  minLabel.textContent = "Depth Window (m)";
  head.appendChild(minLabel);
  field.appendChild(head);

  const dual = document.createElement("div");
  dual.className = "dual-range";
  const track = document.createElement("div");
  track.className = "dual-range-track";
  dual.appendChild(track);

  minControl.input.classList.add("dual-range-input", "dual-range-input-min");
  maxControl.input.classList.add("dual-range-input", "dual-range-input-max");
  dual.appendChild(minControl.input);
  dual.appendChild(maxControl.input);
  field.appendChild(dual);

  const values = document.createElement("div");
  values.className = "dual-range-values";
  const minReadout = document.createElement("span");
  minReadout.textContent = "Min ";
  minReadout.appendChild(minControl.output);
  const maxReadout = document.createElement("span");
  maxReadout.textContent = "Max ";
  maxReadout.appendChild(maxControl.output);
  values.appendChild(minReadout);
  values.appendChild(maxReadout);
  field.appendChild(values);

  maxLabel.remove();

  const update = () => {
    const minBound = Number(minControl.input.min || 0);
    const maxBound = Number(minControl.input.max || maxControl.input.max || 1000);
    const span = Math.max(1, maxBound - minBound);
    const minValue = Math.max(minBound, Math.min(maxBound, Number(minControl.input.value) || minBound));
    const maxValue = Math.max(minValue, Math.min(maxBound, Number(maxControl.input.value) || minValue));
    const minPct = ((minValue - minBound) / span) * 100;
    const maxPct = ((maxValue - minBound) / span) * 100;
    dual.style.setProperty("--min-pct", `${minPct}%`);
    dual.style.setProperty("--max-pct", `${maxPct}%`);

    const rampId = document.getElementById("sounding-color-ramp")?.value || "hydro";
    const inverted = Boolean(document.getElementById("sounding-color-invert")?.checked);
    track.style.setProperty("--ramp-gradient", getSoundingRampGradientCss(rampId, inverted));
  };

  return update;
}

function getSoundingRampGradientCss(rampId, inverted = false) {
  const ramps = {
    hydro: ["#0c2c84", "#225ea8", "#1d91c0", "#41b6c4", "#7fcdbb", "#c7e9b4", "#ffffcc"],
    viridis: ["#440154", "#46327e", "#365c8d", "#277f8e", "#1fa187", "#4ac16d", "#a0da39", "#fde725"],
    turbo: ["#30123b", "#4145ab", "#4675ed", "#39a2fc", "#1bcfd4", "#24eca6", "#61fc6c", "#a4fc3b", "#d6e935", "#fbb938", "#f67f2a", "#e64a19", "#c32503", "#8c0f00"],
    gray: ["#111111", "#2b2b2b", "#474747", "#666666", "#878787", "#aaaaaa", "#cfcfcf", "#f3f3f3"],
  };
  const stops = [...(ramps[rampId] || ramps.hydro)];
  if (inverted) {
    stops.reverse();
  }
  return `linear-gradient(90deg, ${stops.join(", ")})`;
}

function createHeadingDial(input, labelText, variant = "radium-a") {
  const svgNs = "http://www.w3.org/2000/svg";
  const root = document.createElement("div");
  root.className = "heading-dial";
  root.classList.add(`heading-dial--${variant}`);
  root.tabIndex = 0;
  root.setAttribute("role", "slider");
  root.setAttribute("aria-label", labelText);
  root.setAttribute("aria-valuemin", "-180");
  root.setAttribute("aria-valuemax", "180");

  const svg = document.createElementNS(svgNs, "svg");
  svg.setAttribute("viewBox", "0 0 100 100");
  svg.setAttribute("aria-hidden", "true");
  svg.classList.add("heading-dial-svg");

  const ring = document.createElementNS(svgNs, "circle");
  ring.setAttribute("cx", "50");
  ring.setAttribute("cy", "50");
  ring.setAttribute("r", "45");
  ring.setAttribute("class", "heading-dial-ring");
  svg.appendChild(ring);

  const ringInner = document.createElementNS(svgNs, "circle");
  ringInner.setAttribute("cx", "50");
  ringInner.setAttribute("cy", "50");
  ringInner.setAttribute("r", "37");
  ringInner.setAttribute("class", "heading-dial-ring-inner");
  svg.appendChild(ringInner);

  const midTick = document.createElementNS(svgNs, "line");
  midTick.setAttribute("x1", "50");
  midTick.setAttribute("y1", "9");
  midTick.setAttribute("x2", "50");
  midTick.setAttribute("y2", "18");
  midTick.setAttribute("class", "heading-dial-tick");
  svg.appendChild(midTick);

  const quarterTicks = [30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330];
  for (let i = 0; i < quarterTicks.length; i += 1) {
    const tick = document.createElementNS(svgNs, "line");
    tick.setAttribute("x1", "50");
    tick.setAttribute("y1", i % 3 === 2 ? "10" : "12");
    tick.setAttribute("x2", "50");
    tick.setAttribute("y2", i % 3 === 2 ? "18" : "16");
    tick.setAttribute("class", "heading-dial-tick-soft");
    tick.setAttribute("transform", `rotate(${quarterTicks[i]} 50 50)`);
    svg.appendChild(tick);
  }

  const needleGroup = document.createElementNS(svgNs, "g");
  const needle = document.createElementNS(svgNs, "line");
  needle.setAttribute("x1", "50");
  needle.setAttribute("y1", "50");
  needle.setAttribute("x2", "50");
  needle.setAttribute("y2", "14");
  needle.setAttribute("class", "heading-dial-needle");
  needleGroup.appendChild(needle);
  svg.appendChild(needleGroup);

  const center = document.createElementNS(svgNs, "circle");
  center.setAttribute("cx", "50");
  center.setAttribute("cy", "50");
  center.setAttribute("r", "4.2");
  center.setAttribute("class", "heading-dial-center");
  svg.appendChild(center);

  const readout = document.createElement("div");
  readout.className = "heading-dial-readout";

  root.appendChild(svg);
  root.appendChild(readout);

  let dragging = false;
  const snapToZeroDegrees = 5;

  const setFromDegrees = (deg, emit = true) => {
    if (input.disabled) {
      return;
    }
    const wrapped = wrapDialDegrees(deg);
    const snapped = Math.abs(wrapped) <= snapToZeroDegrees ? 0 : wrapped;
    const rounded = Math.round(snapped);
    input.value = String(rounded);
    if (emit) {
      input.dispatchEvent(new Event("input", { bubbles: true }));
    }
    sync();
  };

  const pointerToDegrees = (event) => {
    const rect = root.getBoundingClientRect();
    const cx = rect.left + rect.width * 0.5;
    const cy = rect.top + rect.height * 0.5;
    const x = event.clientX - cx;
    const y = event.clientY - cy;
    return wrapDialDegrees((Math.atan2(x, -y) * 180) / Math.PI);
  };

  root.addEventListener("pointerdown", (event) => {
    if (input.disabled) {
      return;
    }
    dragging = true;
    root.setPointerCapture(event.pointerId);
    setFromDegrees(pointerToDegrees(event), true);
  });

  root.addEventListener("pointermove", (event) => {
    if (!dragging) {
      return;
    }
    setFromDegrees(pointerToDegrees(event), true);
  });

  root.addEventListener("pointerup", () => {
    dragging = false;
  });
  root.addEventListener("lostpointercapture", () => {
    dragging = false;
  });

  root.addEventListener("keydown", (event) => {
    if (input.disabled) {
      return;
    }
    const step = event.shiftKey ? 10 : 1;
    const current = Number(input.value) || 0;
    if (event.key === "ArrowRight" || event.key === "ArrowUp") {
      event.preventDefault();
      setFromDegrees(current + step, true);
    } else if (event.key === "ArrowLeft" || event.key === "ArrowDown") {
      event.preventDefault();
      setFromDegrees(current - step, true);
    } else if (event.key === "Home") {
      event.preventDefault();
      setFromDegrees(0, true);
    }
  });

  const sync = () => {
    const deg = wrapDialDegrees(Number(input.value) || 0);
    needleGroup.setAttribute("transform", `rotate(${deg} 50 50)`);
    readout.textContent = `${deg >= 0 ? "+" : ""}${Math.round(deg)} deg`;
    root.setAttribute("aria-valuenow", String(Math.round(deg)));
    root.classList.toggle("is-disabled", input.disabled);
  };

  sync();
  return { root, sync };
}

function wrapDialDegrees(value) {
  let v = Number(value) || 0;
  while (v > 180) v -= 360;
  while (v < -180) v += 360;
  return v;
}
